// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { systemBuilderProductCardStyles } from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderProductCard";
import { fontConfig } from "@plumberssupply/XDL/PreStyle/typography";
import { color, ellipsis } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

systemBuilderProductCardStyles.cardWrapper = {
    css: css`
        display: flex;
        column-gap: 12px;
        padding-bottom: 8px;
        margin-bottom: 8px;
        &:not(:last-child) {
            border-bottom: 1px solid ${color("common.ui7")};
        }
    `,
};

systemBuilderProductCardStyles.imageWrapper = {
    css: css`
        width: 80px;
        height: 80px;
        min-width: 80px;
    `,
};
systemBuilderProductCardStyles.image = {
    css: css`
        width: auto;
        height: auto;
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
    `,
};

systemBuilderProductCardStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        flex-grow: 1;
    `,
};

systemBuilderProductCardStyles.productTitle = {
    size: 14,
    lineHeight: "17px",
    weight: fontConfig.weight.extraBold,
    css: css`
        ${ellipsis(2)};
    `,
};

systemBuilderProductCardStyles.attributeLabelAndValues = {
    text: {
        size: 12,
        lineHeight: "14px",
        css: css`
            width: auto;
        `,
    },
    heading: {
        weight: fontConfig.weight.bold,
        size: 12,
        lineHeight: "14px",
        css: css`
            text-transform: capitalize;
            white-space: nowrap;
            &:after {
                content: ":";
            }
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            column-gap: 4px;
        `,
    },
};
